import React from 'react';
import { motion } from 'framer-motion';
import { skillsData } from '../data/mock';

const SkillsSection = () => {
  const skillCategories = [
    { title: 'Security', skills: skillsData.security, color: '#00ff88' },
    { title: 'Tools', skills: skillsData.tools, color: '#00ccff' },
    { title: 'Platforms', skills: skillsData.platforms, color: '#ff6b6b' },
    { title: 'Frameworks', skills: skillsData.frameworks, color: '#ffd93d' },
    { title: 'Programming', skills: skillsData.programming, color: '#c084fc' },
    { title: 'Networking', skills: skillsData.networking, color: '#fb923c' },
  ];

  return (
    <section id="skills" className="py-32 relative">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#00ff88]/[0.02] to-transparent" />
      
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-20"
        >
          <span className="text-[#00ff88] text-sm font-medium uppercase tracking-wider mb-4 block">
            Technical Arsenal
          </span>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
            Skills & <span className="gradient-text">Expertise</span>
          </h2>
          <p className="text-white/50 text-lg max-w-2xl mx-auto">
            A comprehensive toolkit for securing and managing enterprise infrastructure.
          </p>
        </motion.div>

        {/* Skills Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {skillCategories.map((category, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="bento-card p-6"
            >
              {/* Category Header */}
              <div className="flex items-center gap-3 mb-5 pb-4 border-b border-white/5">
                <div
                  className="w-3 h-3 rounded-full"
                  style={{ backgroundColor: category.color }}
                />
                <h3 className="font-display font-semibold text-white">
                  {category.title}
                </h3>
              </div>

              {/* Skills List */}
              <div className="flex flex-wrap gap-2">
                {category.skills.map((skill, skillIndex) => (
                  <motion.span
                    key={skillIndex}
                    className="skill-tag"
                    initial={{ scale: 0.8, opacity: 0 }}
                    whileInView={{ scale: 1, opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ delay: index * 0.05 + skillIndex * 0.02 }}
                    whileHover={{ 
                      borderColor: category.color,
                      color: category.color,
                      scale: 1.05
                    }}
                  >
                    {skill}
                  </motion.span>
                ))}
              </div>
            </motion.div>
          ))}
        </div>

        {/* Stats Bar */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="mt-16 bento-card p-8"
        >
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            {[
              { value: '50+', label: 'Technologies' },
              { value: '3', label: 'Certifications' },
              { value: '4+', label: 'Years Experience' },
              { value: '2000+', label: 'Users Managed' }
            ].map((stat, index) => (
              <motion.div
                key={index}
                initial={{ scale: 0.8 }}
                whileInView={{ scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: 0.4 + index * 0.1 }}
              >
                <div className="font-display text-3xl md:text-4xl font-bold text-white mb-2">
                  {stat.value}
                </div>
                <div className="text-white/40 text-sm">{stat.label}</div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default SkillsSection;
